import { productSaveService } from "./productSaveService";
import { propertiesStorage } from "./propertiesStorage";
import { propertiesService } from "./propertiesService";
import i18n from "../i18nService";

const transformSelectValuesList = (selectValues, property, i18nInstance = i18n) => {
    let resultArray = [];
    if(selectValues[0] !== null) {
        selectValues.forEach(it => resultArray.push({
            itemId: it,
            itemTitle: propertiesService.getPropertyValueLocalization(
                it,
                i18nInstance.resolvedLanguage,
                property,
            ),
            included: true,
        }));
    }
    return resultArray;
};

const createJSONString = (listOfData) => {
    const preparedList = [];
    listOfData.forEach(it => preparedList.push(it.itemId));
    return preparedList.length ? JSON.stringify(preparedList) : [];
};

export class productSelectService {
    observersList = [];
    filter = '';
    possibleItems = [];
    selectedItems = [];
    propertyId = '';

    constructor (propertyId) {
        this.propertyId = propertyId;
    }

    resolveDefinitionProperty() {
        const productProperty = productSaveService.getProperty(this.propertyId);
        return propertiesStorage.getItems(true)
            .find(it => it.id === this.propertyId || it.propertyName === productProperty?.propertyName);
    }

    getPossibleItems() {
        const currentProperty = this.resolveDefinitionProperty();
        if(currentProperty && currentProperty.selectValues) {
            this.possibleItems = transformSelectValuesList(
                JSON.parse(currentProperty.selectValues),
                currentProperty,
            ).filter(it => it.itemTitle.toLowerCase().toLowerCase().includes(this.filter));
            return this.possibleItems;
        } else {
            return [];
        }
    }

    getCurrentItems() {
        try {
            const currentValue = productSaveService.getProperty(this.propertyId).value;
            if(currentValue) {
                this.selectedItems = transformSelectValuesList(
                    Array.isArray(currentValue) ? currentValue : JSON.parse(currentValue),
                    this.resolveDefinitionProperty(),
                );
            }
            return this.selectedItems;
        } catch (err) {
            return [];
        }
    }

    getPlaceHolder() {
        return "";
    }

    deleteItem(itemId) { 
        this.selectedItems = this.selectedItems.filter(it => it.itemId !== itemId);
        productSaveService.updateProductProperty(this.propertyId, 'value', createJSONString(this.selectedItems));
        this.notifyItemsChangingObservers();
    }

    addItem(itemId, i18nInstance = i18n) {
        const property = this.resolveDefinitionProperty();
        this.selectedItems.push({
            itemId,
            itemTitle: propertiesService.getPropertyValueLocalization(
                itemId,
                i18nInstance.resolvedLanguage,
                property,
            ),
            included: true,
        });
        productSaveService.updateProductProperty(this.propertyId, 'value', createJSONString(this.selectedItems));
        this.notifyItemsChangingObservers();
    }

    registerItemsChangingObserver(observer) {
        this.observersList.push(observer);
    }

    unRegisterItemsChangingObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
        } catch (err) {
            console.log(err);
        }
    }

    notifyItemsChangingObservers() {
        this.observersList.forEach(observer => observer());
    }

    hasExcludedItemsBlock() {
        return false;
    }

    setSearchFilterValue(searchValue) {
        this.filter = searchValue;
        this.getPossibleItems();
        this.notifyItemsChangingObservers();
    }

    getSearchString() {
        return this.filter;
    }

    isSearchStringChanged() {
        return true;
    }

    handleSearchFilterValue() {}

    getPopupKey() {
        return '';
    }

    getButtonTitle() {
        return '';
    }
}

export const createSelectPropertyService = (propertyId) => {
    return new productSelectService(propertyId);
};
